import { useGlobalStore } from '@/pinia/stores/globalStore'
import { mapState, mapActions } from 'pinia'

export default {
  name: 'timepickerWithTimeformat',
  data () {
    return { }
  },
  computed: mapState(useGlobalStore, {
    timeFormat: 'preferredTimeFormat'
  }),
  methods: {
    ...mapActions(useGlobalStore, [
      'savePreferredTimeFormat'
    ])
  }
}
